import createReducer from '../createReducer';

const initialState = {
    parameters:[],
    designMailing:{},
    sendMailingXHR:null,
    saveMailingXHR:null,
    getMailingDataXHR:null,
    getTextParamsDefaultsXHR:null,
    buyMailingPackageXHR:null
};

const reducer = createReducer('mailing',initialState);

export default reducer;